"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchObjectKeyWithArrayPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const common_1 = require("@angular/common");
let SearchObjectKeyWithArrayPipe = class SearchObjectKeyWithArrayPipe {
    constructor(_datePipe, _decimalPipe) {
        this._datePipe = _datePipe;
        this._decimalPipe = _decimalPipe;
    }
    transform(value, object, key, searchTerms) {
        if (value) {
            if (object) {
                if (key) {
                    if (searchTerms) {
                        return value.filter(item => {
                            for (let sT in searchTerms) {
                                if (item[object] && item[object][key] && (item[object][key] == searchTerms[sT])) {
                                    return true;
                                }
                            }
                            return false;
                        });
                    }
                    else {
                        return value;
                    }
                }
                else {
                    return value;
                }
            }
            else {
                return value;
            }
        }
        else {
            return value;
        }
    }
};
exports.SearchObjectKeyWithArrayPipe = SearchObjectKeyWithArrayPipe;
exports.SearchObjectKeyWithArrayPipe = SearchObjectKeyWithArrayPipe = __decorate([
    (0, core_1.Pipe)({ name: 'searchObjectKeyWithArray', pure: false }),
    __metadata("design:paramtypes", [common_1.DatePipe,
        common_1.DecimalPipe])
], SearchObjectKeyWithArrayPipe);
//# sourceMappingURL=search-object-key-with-array.pipe.js.map